import { useParams, Link } from "react-router-dom";
import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageLayout from "@/components/feature/PageLayout";
import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { videos, categories } from "@/mocks/videoData";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const [activeTab, setActiveTab] = useState(currentCategory.slug);

  const filteredVideos = videos.filter((v) => v.category === activeTab);

  const handleCategoryChange = (catSlug: string) => {
    setActiveTab(catSlug);
    const newCat = categories.find((c) => c.slug === catSlug);
    if (newCat) {
      window.history.replaceState(null, "", `/category/${catSlug}`);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <PageLayout
      seo={
        <SEOHead
          title={`${currentCategory.name} - 苹果视频免费在线观看`}
          description={`苹果视频${currentCategory.name}频道，提供海量免费高清${currentCategory.name}资源，流畅播放不卡顿。香蕉视频、红桃视频、91视频、蜜桃视频热门${currentCategory.name}全集在线观看。`}
          keywords={`${currentCategory.name},苹果视频,免费在线观看,高清,流畅,不缓冲`}
          canonicalUrl={`/category/${currentCategory.slug}`}
        />
      }
    >
      <Navbar />
      <div className="pt-20">
        <div className="px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: currentCategory.name },
              ]}
            />

            <div className="mt-6 mb-8">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                {currentCategory.name}
              </h1>
              <p className="text-sm text-foreground-600 mt-2">
                发现最精彩的{currentCategory.name}资源，高清流畅免费在线观看
              </p>
            </div>

            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => handleCategoryChange(cat.slug)}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeTab === cat.slug
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </button>
              ))}
            </div>

            {filteredVideos.length === 0 ? (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无相关内容，敬请期待</p>
              </div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
                {filteredVideos.map((video) => (
                  <Link
                    key={video.id}
                    to={`/article/${video.id}`}
                    className="group bg-background-50 rounded-xl overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
                  >
                    <div className="relative overflow-hidden aspect-video">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        title={`${video.title} - 苹果视频免费在线观看`}
                        loading="lazy"
                      />
                      <div className="absolute top-2 right-2 bg-foreground-950/80 text-background-50 text-xs font-bold px-2 py-0.5 rounded">
                        {video.rating}
                      </div>
                      <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/20 transition-colors flex items-center justify-center">
                        <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity">
                          <i className="ri-play-fill text-lg"></i>
                        </span>
                      </div>
                    </div>
                    <div className="p-3 md:p-4">
                      <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                        {video.title}
                      </h3>
                      <div className="flex items-center gap-3 mt-1.5">
                        <span className="text-xs text-foreground-500">{video.year}</span>
                        <span className="text-xs text-amber-500 font-medium flex items-center gap-0.5">
                          <i className="ri-star-fill text-[10px]"></i>
                          {video.rating}
                        </span>
                        <span className="text-xs text-foreground-500">{video.duration}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </PageLayout>
  );
}